export default function categoriesListActive() {
  const categories_list_items = document.querySelectorAll(
    ".categories-list__list a"
  );
  categories_list_items.forEach((item) => {
    const item_class = item.getAttribute("class");
      // console.log(item_class, "item_class");
      // console.log(window.location.href, "window.location.href");
    if (window.location.href.includes(item_class)) {
      item.classList.add("active");
    }
  });
}
